module.exports = __webpack_public_path__ + "img/feather.e909dd18.svg";